import { mainApi } from "../services/main/api";

const extendedApi = mainApi.injectEndpoints({
    endpoints: builder => ({
        getArtifactDetailsById: builder.query<
            GetArtifactDetailsByIdResponse,
            GetArtifactDetailsByIdRequest
        >({
            query: (request: GetArtifactDetailsByIdRequest) => ({
                url: "getArtifactDetailsById",
                body: request,
                method: "POST",
            }),
            keepUnusedDataFor: 1,
        }),
    }),
    overrideExisting: false,
});

export const { useGetArtifactDetailsByIdQuery, useLazyGetArtifactDetailsByIdQuery } = extendedApi;

export interface GetArtifactDetailsByIdRequest {
    artifactType: "DOCUMENT" | "PARCEL" | "REAL_PROPERTY" | "PERSONAL_PROPERTY" | string;
    artifactId: string;
    businessUseCase: string;
}

export interface GetArtifactDetailsByIdResponse {
    artifactId: string;
    artifactType: string;
    createdOn: string;
    createdBy: string;
    updatedOn: string;
    updatedBy: string;
    artifactDetails: IArtifactDetails;
}

export interface IArtifactDetails {
    // Common Fields
    grossLeasableAreaUnit?: string;
    siteArea?: string;
    ownershipStatus?: string;
    association?: IAssociationDetails;
    saleDate?: string;
    dateClosed?: string;
    yearBuilt?: string;
    dateOpened?: string;
    dateRevised?: string;
    filingDueDate?: string;
    appealDeadline?: string;
    dateOfHearing?: string;
    secDivision?: string;
    currency?: string;
    grossBuildingAreaUnit?: string;
    siteCode?: string;
    address?: IAddressDetails;
    comments?: string;
    grossBuildingArea?: string;
    salePrice?: string;
    siteUsableArea?: string;
    assignedUsers?: string;
    siteUsableAreaUnit?: string;
    grossLeasableArea?: string;
    siteAreaUnit?: string;
    otherDescription?: string;
    constructionCosts?: string;
    contacts?: string;
    propertyNumber?: string;
    status?: string;
    leaseRate?: string;
    propertyId?: string;
    appealNumber?: string;
    appraisedValueAmount?: string;
    appraisedValueCurrency?: string;
    assessedValueAmount?: string;
    assessedValueCurrency?: string;
    buildingValueAmount?: string;
    buildingValueCurrency?: string;
    checkNumber?: string;
    landValueAmount?: string;
    landValueCurrency?: string;
    marketValueAmount?: string;
    marketValueCurrency?: string;
    propertyDescription?: string;
    reasonForCheck?: string;
    taxableValueAmount?: string;
    taxableValueCurrency?: string;
    taxAmountAmount?: string;
    taxAmountCurrency?: string;
    taxBillEstimateAmount?: string;
    taxBillEstimateCurrency?: string;
    taxYear?: string;
    tenantName?: string;
    totalTaxesOwedAmount?: string;
    totalTaxesOwedCurrency?: string;
    totalValueAmount?: string;
    totalValueCurrency?: string;
    trueAmountDueAmount?: string;
    trueAmountDueCurrency?: string;
    artifactId?: string;
    artifactType?: string;
    treasureStatus?: string;
    failureReason?: string;

    // Property Specific Fields
    propertyType?: string;
    propertySubType?: string;
    generalLedgerNumber?: string;
    subType?: string;
    entityCode?: string;
    entityName?: string;

    // Parcel Specific Fields
    entity?: string;
    parcelType?: string;
    parcelSubType?: string;
    parcelNumber?: string;

    // Document Specific Fields
    documentType?: string;
    associatedPropertyType?: string;
    dueDate?: string;
    bblCode?: string;
    invoiceNumber?: string;
    assessedValue?: number;
    totalValue?: string;
    numberOfPayments?: string | number;
    earliestPaymentDueDate?: string;
    receiveDate?: string;
    marketValue?: string;
    landValue?: string;
    totalTaxesOwed?: number;
    accountNumber?: string;
    canopyId?: string;
    taxableValue?: number;
    trueAmountDue?: number;
    mailId?: string;
    documentS3Key?: string;
    createdByUser?: string;
    companyName?: string;
    assignedTo?: string;
    buildingValue?: string;
    discounts?: string;
    appraisedValue?: string;
    taxDistrict?: string;
    buildingCode?: string;
    documentS3PreSignedUrl?: string;

    // Comment Specific Fields
    text?: string;
    commentedBy?: string;
}

export interface IAddressDetails {
    county: string;
    country: string;
    zipCode: string;
    streetAddress: string;
    state: string;
    city: string;
    jurisdiction: string;
}

export interface IAssociationDetails {
    parcelAssociation?: IParcelAssociation;
    documentAssociation?: IDocumentAssociation[];
    commentAssociation?: ICommentAssociation;
    appealAssociation?: IAppealAssociation;
}

export interface IParcelAssociation {
    associatedPropertyArtifactId: string;
}

export interface IAppealAssociation {
    associatedPropertyArtifactId: string;
}

export interface IDocumentAssociation {
    parcelArtifactId: string;
}

export interface ICommentAssociation {
    associatedArtifactType: string;
    associatedArtifactId: string;
}
